// extracted by mini-css-extract-plugin
module.exports = {"tableTitleCell":"EmployeeInformation_tableTitleCell__1In3H","shynar":"EmployeeInformation_shynar__s5NPu"};